import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91fec98e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "log_close" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17ZM9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18ZM9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.5289 7.30662C10.7944 6.97289 11.3038 6.90035 11.6667 7.1446C12.0295 7.38885 12.1083 7.8574 11.8428 8.19112L9.4818 11.1584C9.1201 11.613 8.44851 11.6647 8.02143 11.271L6.23776 9.6264C5.92021 9.33362 5.92083 8.8595 6.23913 8.56741C6.55743 8.27533 7.07289 8.27589 7.39043 8.56867L8.62154 9.70376L10.5289 7.30662Z",
      fill: "#15A336"
    })
  ])
], -1))
const _hoisted_2 = { class: "log_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([
      _ctx.alertType === 'error'
        ? { backgroundColor: ' #db2121' }
        : { backgroundColor: ' #15a336' },
    ]),
    class: "log",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeAlert')))
  }, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.alertMessage), 1)
    ])
  ], 4))
}